import { searchMultipleKeys } from "@domains/utils/search";
class TicketsPresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    getTicketsData() {
        this.actions.getTicketsData.hideError();
        this.actions.getTicketsData.startLoader();
        this.usecase.ticketsDetails.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.getTicketsData.getTicketsData(data);
                }
                this.actions.getTicketsData.stopLoader();
            },
            onError: (error) => {
                this.actions.getTicketsData.setError({ isOpen: true, error });
                this.actions.getTicketsData.stopLoader();
            },
        }, null);
    }
    createTicketData(req) {
        this.actions.createTicketData.hideError();
        this.actions.createTicketData.startLoader();
        this.usecase.createTicketDetails.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.createTicketData.createTicketData(data);
                }
                this.actions.createTicketData.stopLoader();
            },
            onError: (error) => {
                this.actions.createTicketData.setError({ isOpen: true, error });
                this.actions.createTicketData.stopLoader();
            },
        }, req);
    }
    applySearching(searchState, data) {
        let resultData = searchMultipleKeys(data, (['ticketId', 'comments', 'description']), searchState);
        if (resultData && resultData.length > 0) {
            return resultData;
        }
        else {
            return [];
        }
    }
}
export default TicketsPresenter;
